import { api } from '@/lib/api';

export type StepStatus = 'done' | 'pending' | 'dismissed';
export type StepCategory = 'required' | 'recommended' | 'optional';

export interface OnboardingStep {
  id: string;
  title: string;
  description: string;
  cta: string;
  ctaHref: string;
  status: StepStatus;
  category: StepCategory;
  unlocks: string;
}

export interface OnboardingState {
  state: { dismissed: string[]; completed_at: string | null };
  steps: OnboardingStep[];
  progress: {
    done: number;
    total: number;
    percent: number;
    requiredDone: boolean;
    readyToDismiss: boolean;
  };
  user: { email: string };
}

export async function getOnboarding(): Promise<OnboardingState> {
  // Let React Query own the error state; the UI shows a real error message
  // instead of silently rendering an empty 0/0 checklist.
  return api('/v1/onboarding');
}

export async function dismissOnboardingStep(step: string) {
  return api('/v1/onboarding/dismiss', { method: 'POST', body: JSON.stringify({ step }) });
}

export async function completeOnboarding() {
  return api('/v1/onboarding/complete', { method: 'POST' });
}

export async function resetOnboarding() {
  return api('/v1/onboarding/reset', { method: 'POST' });
}
